import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import { ArrowForwardIos } from "@mui/icons-material";
import { ProjectType } from "src/components/ProjectType";

export const ProjectCard = ({
  url,
  title,
  summary,
  description,
  roles,
  studio,
  technologies,
  collaborators,
  platforms,
  year,
  tags,
  haveTags,
  imageSrc,
  hasVideo,
  startVideoTime = 0,
  videoSrc,
  isCoverType,
  delay,
  projectType,
  isCheckMoreProjects
}) => {
  const videoRef = useRef<HTMLVideoElement>(null); // Explicitly typing the ref

  useEffect(() => {
    if (hasVideo && videoRef.current) {
      videoRef.current.currentTime = startVideoTime;
    }
  }, [videoSrc, hasVideo, startVideoTime]);

  // Fix for ProjectCard.tsx handleMouseEnter
  const handleMouseEnter = (e) => {
    const videoElement = e.currentTarget.querySelector("video") as HTMLVideoElement;
    if (videoElement) {
      // Handle the play promise to avoid AbortError
      const playPromise = videoElement.play();
      
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // Auto-play was prevented or something else went wrong
          // We can silently handle this error
        });
      }
    }
  };

  // Fix for ProjectCard.tsx handleMouseLeave
  const handleMouseLeave = (e) => {
    const videoElement = e.currentTarget.querySelector("video") as HTMLVideoElement;
    if (videoElement) {
      // Only pause if the video is actually playing
      if (!videoElement.paused) {
        videoElement.pause();
      }
    }
  };

  return (
    <div
      className={isCheckMoreProjects ? "project-preview landing-card" : "project-preview"}
      style={{ animationDelay: `${delay}s` }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Link
        to={isCheckMoreProjects ? `/projects` : `/projects/${url.toLowerCase()}`}
        onClick={() => window.scrollTo(0, 0)}
        className="proj-imgbx project-link"
      >

        <div className={hasVideo ? "proj-img-container-player-web" : "proj-img-container-web"}>
          {hasVideo ? (
            <video
              ref={videoRef}
              className={isCoverType ? "imgcover" : "imgfill"}
              src={videoSrc}
              muted
              loop
              preload="auto"
              onLoadedMetadata={() => {
                if (videoRef.current) {
                  videoRef.current.currentTime = startVideoTime;
                }
              }}
            />
          ) : (
            <img
              className={isCoverType ? "imgcover" : "imgfill"}
              src={imageSrc}
              alt={title}
            />
          )}
        </div>

        {/* <div className="project-tags">{GetTagString(tags)}</div> */}
        {/* {haveTags && studio == null && (
          <div className="project-tags">
            <GroupIcon style={iconContainerStyle} /><span>{collaborators != null && collaborators.length > 0 ? collaborators.length : "1"}</span>

            {platforms != null && platforms.length > 0 && (
              <>
                <DevicesIcon style={iconContainerStyle} />
                <span>{platforms[0]}</span>
              </>
            )}

            {technologies != null && technologies.length > 0 && (
              <>
                <ConstructionIcon style={iconContainerStyle} />
                <span>{technologies[0]}</span>
              </>
            )}

            <EventIcon style={iconContainerStyle} /><span>{year}</span>
          </div>
        )} */}
        {/* {haveTags && studio != null && (
          <div className="project-tags">
            {studio != null && (
              <>
                <Engineering style={iconContainerStyle} /><span>Professional</span>
              </>
            )}

            {platforms != null && platforms.length > 0 && (
              <>
                <DevicesIcon style={iconContainerStyle} />
                <span>{platforms[0]}</span>
              </>
            )}

            {technologies != null && technologies.length > 0 && (
              <>
                <ConstructionIcon style={iconContainerStyle} />
                <span>{technologies[0]}</span>
              </>
            )}
          </div>
        )} */}

        <div className="proj-txtx">
          <div className="proj-txtx-arrow">
            {/* <h4 style={{
              fontSize: title.length > 17
                ? Math.max(1, 1.6 - ((title.length - 17) * 0.03)) + "rem"
                : "1.6rem"
            }}>{title}</h4> */}
            <h4>{title}</h4>
            <ArrowForwardIos />
          </div>
          <div className="project-preview-detail">
            <div className="project-roles">{GetProjectTypeString(projectType)}</div>
            {/* <div className="project-roles">{GetTagString(roles, studio)}</div> */}
            {/* {summary && <p id="project-summary">{summary}</p>} */}
          </div>
        </div>
      </Link>
    </div>
  );
};

export function GetProjectTypeString(projectType) {
  switch (projectType) {
    case ProjectType.COLLEGE:
      return "Personal project";
    case ProjectType.PERSONAL:
      return "Personal project";
    case ProjectType.PROFESSIONAL:
      return "Professional project";
    case ProjectType.GAMEJAM:
      return "Game jam project";
    case ProjectType.STUDY:
      return "Study project";
    case ProjectType.SIDE:
      return "Side project";
    case ProjectType.PROTOTYPE:
      return "Personal project";
    default:
      return "";
  }
}

// function GetTagString(tags, studio) {
//   const combinedTags = [...(tags || []), ...(studio || [])];
//   return combinedTags.length > 0
//     ? combinedTags.map((tag, index) => (
//       <React.Fragment key={index}>
//         {index > 0 && <span> | </span>}
//         {tag}
//       </React.Fragment>
//     ))
//     : null;
// }